export default __webpack_public_path__ + "static/media/icon_EMSD1.1035989f.png";